import request from '@/utils/request'

export function createAdminUser(data) {
  return request({
    url: '/api/adminUser/create',
    method: 'post',
    data
  })
}

export function deleteAdminUser(data) {
  return request({
    url: '/api/adminUser/delete',
    method: 'post',
    data
  })
}

export function updateAdminUser(data) {
  return request({
    url: '/api/adminUser/update',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/api/adminUser/loadUserInfo',
    method: 'post'
  })
}

export function detailAdminUser(data) {
  return request({
    url: '/api/adminUser/detail',
    method: 'post',
    data
  })
}

export function queryAdminUserPageList(data) {
  return request({
    url: '/api/adminUser/pageList',
    method: 'post',
    data
  })
}

export function queryAdminUserSelectList(data) {
  return request({
    url: '/api/adminUser/selectList',
    method: 'post',
    data
  })
}

export function queryAdminUserSelectPageList(data) {
  return request({
    url: '/api/adminUser/pageSelectList',
    method: 'post',
    data
  })
}
